import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

// Icon-only back button for detail-page headers. Prefers real browser history so
// it returns to wherever the user actually came from (a file can be opened from
// the library, a job, or a source); falls back to `fallback` on a direct load
// where there's no in-app history to pop.
export default function BackButton({
  fallback = '/',
  className = '',
}: {
  fallback?: string;
  className?: string;
}) {
  const navigate = useNavigate();
  const goBack = () => {
    if ((window.history.state?.idx ?? 0) > 0) navigate(-1);
    else navigate(fallback);
  };
  return (
    <button
      onClick={goBack}
      aria-label="Back"
      title="Back"
      className={`inline-flex items-center text-coolslate hover:text-graphite transition-colors cursor-pointer ${className}`}
    >
      <ArrowLeft className="w-5 h-5" />
    </button>
  );
}
